import type { FC } from "react";

import { Disclaimer as UIDisclaimer } from "@jti/ui/eva-components/SoftAgeVerification/components/Disclaimer";

import { usePageConfig } from "@/context/PageConfigContext";

import type { disclaimerInputs } from "./Disclaimer.builder";

export type DisclaimerProps = BuilderComponentProps<typeof disclaimerInputs>;

export const Disclaimer: FC<DisclaimerProps> = (props) => {
  const { darkMode } = usePageConfig();
  return <UIDisclaimer isDarkMode={darkMode} {...props} />;
};

export default Disclaimer;
